import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/settings/printerBlock/printerBlockRow.template.html';

import Model from '../../models/settings/settings.model.ts';

import i18n  from "l10n";

export default Backbone.View.extend({
    tagName: 'div',
    className: 'col-12',
	template: Handlebars.compile(Template),
    model: null,
    stompSubscription: null,
    initialize: function (options) {
        var self = this;

        this.stompSubscription = null;

        if(options && options.model) {
            this.model = new Model(options.model);
            this.queueData = options.queue;
        }
        else {
            this.model = new Model({
                "id": -1,
                "name": "-",
                "value": "-"
            });

        }

	},
	superRender: Backbone.View.prototype.render,
	render: function (withAnimation) {
		var self = this;
		this.superRender();

        var templateParams = {
            "settings": this.model.toJSON(),
            "queue": this.queueData
        }

        var templateData = this.template( templateParams );

		this.$el.html( templateData );

        return this;
	},
	events: {
        "click #saveConfiguration": "saveConfiguration"
	},
	setupAjax: function() {
        var self = this;

        $.ajaxSetup({
            beforeSend: function (xhr) {
                var lang = i18n.lng() == "en" ? "en-GB" : "el-GR";

                xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                xhr.setRequestHeader('Accept-Language', lang);

            },
            error: function (xhr, exception) {

            }
        });
    },
    saveConfiguration: function(e) {
        const value = this.$el.find("#" + this.model.get("name")).val();

        this.model.set("value", value);

        var $btn = $(e.currentTarget);

        if(!$btn.hasClass("disabled")) {
            $btn.addClass("disabled");
        }
        else {
            return;
        }

        this.saveSetting($btn);
    },
    saveSetting: async function($btn) {
        var self = this;
        this.setupAjax();

        await window.ping();

        $.ajaxDefaultQ({
            url: "rest/api/admin/settings",
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify( this.model.toJSON() )

        }).done(function (response) {

            $btn.notify(i18n.t("settings.savedSuccessfully"), { position:"top center", className: "success"});

            $btn.removeClass("disabled");

        }).fail(function (response) {

            console.error("response: ", response);

            $btn.notify(i18n.t("settings.errorOccurred"), { position:"top center", className: "error"});
            $btn.removeClass("disabled");

        });
    }
});


